import * as React from 'react';
import { SVGProps } from 'react';

const IconMailSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3 4a1 1 0 0 0-1 1v1.066l10 6.518 10-6.518V5a1 1 0 0 0-1-1H3z" />
    <path d="m22 8.453-10 6.519-10-6.52V19a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V8.453z" />
  </svg>
);
export default IconMailSizeM;
